import { render, staticRenderFns } from "./labelChoose.vue?vue&type=template&id=79987142"
import script from "./labelChoose.vue?vue&type=script&lang=js"
export * from "./labelChoose.vue?vue&type=script&lang=js"
import style0 from "./labelChoose.vue?vue&type=style&index=0&id=79987142&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79987142')) {
      api.createRecord('79987142', component.options)
    } else {
      api.reload('79987142', component.options)
    }
    module.hot.accept("./labelChoose.vue?vue&type=template&id=79987142", function () {
      api.rerender('79987142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reportForm/exportManage/labelChoose.vue"
export default component.exports